export const language = {
	computed: {
		language() {
			return this.$store.getters['language/getLanguage'];
		},
	},
};
